import React, { Component } from "react";

import Dropdown from "@acadia-ui/dropdown";
import Button, { BUTTON_DISPLAY } from "@acadia-ui/button";
import DatePicker from "@acadia-ui/datepicker";
import _ from "lodash";

import "./FilterV2.scss";
import { createPortal } from "react-dom";

class Filter extends Component {
	constructor(props) {
		super(props);
		this.state = {
			filterOptions: [{ dataKey: null, dataValue: null }],
			previousFilterOptions: [{ dataKey: null, dataValue: null }]
		};
	}

	componentDidUpdate = (prevProps) => {
		if (prevProps.filterEnabled !== this.props.filterEnabled && this.props.filterEnabled === false) {
			this.setState({
				filterOptions: [{ dataKey: null, dataValue: null }],
				previousFilterOptions: [{ dataKey: null, dataValue: null }]
			});
		}
		if (!_.isEqual(prevProps.filterOptions, this.props.filterOptions)) {
			this.setState({
				filterOptions: this.props.filterOptions.length ? JSON.parse(JSON.stringify(this.props.filterOptions)) : [{ dataKey: null, dataValue: null }],
				previousFilterOptions: this.props.filterOptions.length ? JSON.parse(JSON.stringify(this.props.filterOptions)) : [{ dataKey: null, dataValue: null }]
			});
		}
	};

	componentDidMount = () => {
		if (this.props.filterOptions?.length > 0) {
			this.setState({
				filterOptions: JSON.parse(JSON.stringify(this.props.filterOptions)),
				previousFilterOptions: JSON.parse(JSON.stringify(this.props.filterOptions))
			});
		}
	};

	dataFieldChanged = (value, type, index) => {
		const { filterOptions } = this.state;
		if (type === "dataKey") {
			filterOptions[index].dataValue = null;
		}
		filterOptions[index][type] = value;
		this.setState({ filterOptions });
	};

	getFilterData = () => {
		const dataProvider = this.props.dataTableApi?.current?.dataProvider;
		const data = this.props.data || dataProvider?.data || [];
		const searchValue = dataProvider?.searchQuery || "";

		return searchValue !== "" && dataProvider?.doSearch ? dataProvider.doSearch(data, searchValue, []) : data;
	};

	getAvailableDataValueOptions = (dataKey) => {
		const data = this.getFilterData();

		return (dataKey.Options || []).filter((dataValue) => {
			return data.some((row) => {
				if (dataKey.Name === "IsDraft") {
					return dataValue.OptionID === (row.IsDraft === "True" ? "True" : "False");
				}

				if (dataKey.Name === "ParentDescription") {
					if (this.props.hierarchyLevel === "LineItem") {
						return dataValue.OptionID === row.InsertionOrderID;
					}

					if (this.props.hierarchyLevel === "Placement") {
						return dataValue.OptionID === row.PackageID || (dataValue.OptionID === "STANDALONE" && row.PackageType === "Standalone");
					}
				}

				if (dataKey.Label === "Prisma Status" || dataKey.Label === "DV360 Status") {
					return dataValue.OptionID === row.ExternalSystemStatusID;
				}

				if (dataKey.Label === "TM Status") {
					return dataValue.OptionID === row.TraffickingPlacementStatusID || (dataValue.OptionID === "1" && row.TraffickingPlacementStatusID === "");
				}

				return dataValue.OptionLabel === row[dataKey.Name] || dataValue.OptionID === row[dataKey.Name];
			});
		});
	};

	renderFilterOptions = () => {
		const externalSystemIDOptions = [
			{ OptionLabel: "Draft", OptionID: "1" },
			{ OptionLabel: "Error", OptionID: "2" },
			{ OptionLabel: "Success", OptionID: "3" },
			{ OptionLabel: "Pending", OptionID: "4" },
			// { OptionLabel: "Not Eligible", OptionID: "5" },
			{ OptionLabel: "Edit", OptionID: "6" }
		];
		const traffickingPlacementStatusIDOptions = [
			{ OptionLabel: "Draft", OptionID: "1" },
			{ OptionLabel: "Processing", OptionID: "2" },
			// { OptionLabel: "Warning", OptionID: "3" },
			{ OptionLabel: "Error", OptionID: "4" },
			{ OptionLabel: "Success", OptionID: "5" }
		];
		const renderedFilterOptions = [];
		let dataKeyOptions = [];
		const hiddenColumns = this.props.showHideColumnsProps?.columns
			?.filter((column) => {
				return column.selected === false;
			})
			.map((column) => {
				return column.name;
			});
		const selectedDataKeys = this.state.filterOptions.map((option) => {
			if (option.dataKey !== null) {
				return option.dataKey.Label;
			}
		});
		if (this.props.config) {
			Object.keys(this.props.config).forEach((bucket) => {
				if (bucket !== "ChildData" && bucket !== "RegEx") {
					this.props.config[bucket].forEach((dataKey) => {
						if (
							// (dataKey.DataType === 'Select' || dataKey.DataType === 'Date') &&
							dataKey.DataType === "Select" &&
							dataKey.FieldType !== "Hidden" &&
							dataKey.Name !== "IsDoNotUse" &&
							dataKey.IsSummarizedHeader === true
						) {
							dataKey.label = dataKey.Label;
							dataKey.value = dataKey.ID;
							dataKeyOptions.push(dataKey);
						}
					});
				}
			});
		}

		if (this.props.statusFilter && this.props.statusFilter !== false) {
			Object.keys(this.props.statusFilter).forEach((platform, index) => {
				if (this.props.statusFilter[platform] === true) {
					// prevent TM Status on package tab
					if (this.props.hierarchyLevel === "Package" && platform === "GCMEnabled") {
						return;
					}

					dataKeyOptions.push({
						Label: platform === "prismaEnabled" ? "Prisma Status" : platform === "DV360Enabled" ? "DV360 Status" : platform === "GCMEnabled" ? "TM Status" : "",
						label: platform === "prismaEnabled" ? "Prisma Status" : platform === "DV360Enabled" ? "DV360 Status" : platform === "GCMEnabled" ? "TM Status" : "",
						value: `Status_${index}`,
						type: "Status",
						Options:
							platform === "prismaEnabled" || platform === "DV360Enabled"
								? externalSystemIDOptions
								: platform === "GCMEnabled"
									? traffickingPlacementStatusIDOptions
									: [],
						DataType: "Select"
					});
				}
			});
		}

		if (hiddenColumns) {
			dataKeyOptions = dataKeyOptions.filter((option) => {
				return !hiddenColumns.includes(option.Label);
			});
		}

		// if this.props.data doesn't have at least one element with IsDraft "True", then don't show the filter
		if (this.getFilterData().some((row) => row.IsDraft === "True")) {
			dataKeyOptions.push({
				label: "Draft Status",
				Name: "IsDraft",
				Label: "Draft Status",
				value: "IsDraft",
				DataType: "Select",
				Options: [
					{ OptionLabel: "Draft", OptionID: "True" },
					{ OptionLabel: "Active", OptionID: "False" }
				]
			});
		}

		dataKeyOptions = dataKeyOptions
			.map((dataKey) => {
				return {
					...dataKey,
					Options: this.getAvailableDataValueOptions(dataKey)
				};
			})
			.filter((dataKey) => dataKey.DataType !== "Select" || dataKey.Options.length > 0);

		this.state.filterOptions.forEach((option, index) => {
			const dataValueOptions = option.dataKey !== null ? this.getAvailableDataValueOptions(option.dataKey) : [];

			renderedFilterOptions.push(
				<div className="filterDKDVContainer" key={`filterOptionKey_${index}`}>
					<div className={"filterDKDVleft"}>
						<div className="filterDataKeyContainer">
							<Dropdown
								name="filterDataKey"
								value={option.dataKey}
								id={`filterDataKey_${index}`}
								isClearable={true}
								isSearchable={true}
								options={dataKeyOptions.filter((dataKey) => {
									return !selectedDataKeys.includes(dataKey.Label);
								})}
								placeholder="Data Key"
								onChange={(e) => this.dataFieldChanged(e, "dataKey", index)}
								invert={true}
							>
								Data Key
							</Dropdown>
						</div>
						<div className="filterDataValueContainer">
							{option.dataKey?.DataType === "Select" ? (
								<Dropdown
									name="filterDataValue"
									value={option.dataValue}
									id={`filterDataValue_${index}`}
									isClearable={true}
									isSearchable={true}
									multiple
									options={dataValueOptions.map((dataValue) => ({ ...dataValue, label: dataValue.OptionLabel, value: dataValue.OptionID }))}
									placeholder="Select A Data Value"
									onChange={(e) => this.dataFieldChanged(e, "dataValue", index)}
									disabled={option.dataKey === null}
									invert={true}
								>
									Data Value
								</Dropdown>
							) : option.dataKey?.DataType === "Date" ? (
								<DatePicker id={`filterDataValue_${index}`} onChange={(value) => this.dataFieldChanged(value, "dataValue", index)} value={option.dataValue}>
									{option.dataKey.Label}
								</DatePicker>
							) : (
								<Dropdown
									name="filterDataValue"
									value={null}
									id={`filterEmptyDataValue_${index}`}
									options={[]}
									placeholder="Select A Data Key First"
									disabled={true}
									invert={true}
								>
									Data Value
								</Dropdown>
							)}
						</div>
					</div>
					<div className="filterActions">
						<Button
							display={BUTTON_DISPLAY.ICON}
							onClick={() => {
								const { filterOptions } = this.state;
								filterOptions.splice(index, 1);
								this.setState({ filterOptions });
							}}
							disabled={index === 0}
							icon={"icon-delete"}
							data-tracking-id-alt={`remove-filter-option`}
						>
							Delete
						</Button>
						<Button
							display={BUTTON_DISPLAY.ICON}
							onClick={() => {
								const { filterOptions } = this.state;
								filterOptions.push({ dataKey: null, dataValue: null });
								this.setState({ filterOptions });
							}}
							disabled={option.dataKey === null || option.dataValue === null}
							icon={"icon-add"}
							data-tracking-id-alt={`add-filter-option`}
						>
							Add
						</Button>
					</div>
				</div>
			);
			renderedFilterOptions.push(<div key="filterDKDVdivider" className="filterDKDVdivider" />);
		});
		return renderedFilterOptions;
	};

	cancelFilters = () => {
		this.setState({
			filterOptions: JSON.parse(JSON.stringify(this.state.previousFilterOptions))
		});
		// this.props.handleFilter(null, false);
		this.props.onClose();
	};

	clearFilters = () => {
		this.setState({
			filterOptions: [{ dataKey: null, dataValue: null }]
		});
		this.props.handleFilter(null, false);
	};

	returnSearchedValues = (searchTerm) => {
		const searchableFields = [];
		const filteredData = [];
		Object.keys(this.props.config).forEach((bucket) => {
			if (Array.isArray(this.props.config[bucket])) {
				this.props.config[bucket].forEach((field) => {
					if (field.IsSummarizedHeader === true) {
						searchableFields.push(field.Name);
					}
				});
			}
		});
		this.props.data.forEach((row) => {
			for (const field of searchableFields) {
				if (row[field]) {
					if (row[field].toLowerCase().includes(searchTerm.toLowerCase())) {
						filteredData.push(row);
						break;
					}
				}
			}
		});
		return filteredData;
	};

	filterValues = () => {
		const statusAPINames = ["Prisma Status", "DV360 Status", "TM Status"];
		const filteredValues = [];
		const searchValue = this.props.dataTableApi?.current?.toolbarApi?.curent?.searchValue || "";
		const dataToFilter = searchValue !== "" ? this.returnSearchedValues(searchValue) : this.props.data;
		dataToFilter.forEach((row) => {
			let nonMatchingValue = false;
			this.state.filterOptions
				.filter((option) => {
					return option.dataKey !== null;
				})
				.forEach((option) => {
					if (nonMatchingValue !== true) {
						if (!statusAPINames.includes(option.dataKey.Label)) {
							if (option.dataKey.DataType === "Select") {
								if (option.dataKey.Name === "IsDraft") {
									const selectedDraftStatuses = option?.dataValue?.map?.(({ OptionID }) => OptionID) || [];
									const rowDraftStatus = row.IsDraft === "True" ? "True" : "False";

									if (!selectedDraftStatuses.includes(rowDraftStatus)) {
										nonMatchingValue = true;
									}
								}
								if (
									option.dataKey.Name !== "IsDraft" &&
									option.dataKey.Name !== "ParentDescription" &&
									(!row[option.dataKey.Name] || !option?.dataValue?.map?.(({ OptionLabel }) => OptionLabel)?.includes(row[option.dataKey.Name]))
								) {
									nonMatchingValue = true;
								}
								if (option.dataKey.Name === "ParentDescription") {
									const parentOptionIDs = option.dataValue.map((value) => {
										return value.OptionID;
									});
									if (this.props.hierarchyLevel === "LineItem" && !parentOptionIDs.includes(row.InsertionOrderID)) {
										nonMatchingValue = true;
									}
									if (this.props.hierarchyLevel === "Placement") {
										const includesStandalone = parentOptionIDs.includes("STANDALONE");
										if (!parentOptionIDs.includes(row.PackageID) && row.PackageType !== "Standalone") {
											nonMatchingValue = true;
										}
										if (!includesStandalone && row.PackageType === "Standalone") {
											nonMatchingValue = true;
										}
									}
								}
							} else if (row[option.dataKey.Name] && row[option.dataKey.Name] !== "") {
								try {
									const filterDate = new Date(option.dataValue);
									const rowDate = new Date(row[option.dataKey.Name]);
									if (option.dataKey.Name === "StartDate") {
										if (filterDate > rowDate) {
											nonMatchingValue = true;
										}
									} else if (option.dataKey.Name === "EndDate") {
										if (filterDate < rowDate) {
											nonMatchingValue = true;
										}
									}
								} catch {
									console.log("error comparing dates");
								}
							} else {
								nonMatchingValue = true;
							}
						} else {
							if (option.dataKey.Label === "Prisma Status" || option.dataKey.Label === "DV360 Status") {
								if (
									!row.ExternalSystemStatusID ||
									!option?.dataValue
										?.map((key) => {
											return key.OptionID;
										})
										.includes(row.ExternalSystemStatusID)
								) {
									nonMatchingValue = true;
								}
							}
							if (option.dataKey.Label === "TM Status") {
								// Consider it a draft if the TraffickingPlacementStatusID is an empty string
								const emptyStringDraftMatch =
									row.TraffickingPlacementStatusID === "" &&
									option.dataValue.find((key) => {
										return key.OptionID === "1";
									});
								if (
									!option?.dataValue
										?.map((key) => {
											return key.OptionID;
										})
										.includes(row.TraffickingPlacementStatusID) &&
									!emptyStringDraftMatch
								) {
									nonMatchingValue = true;
								}
							}
						}
					}
				});

			// always show cloned records
			if (row.UniqueID?.includes("duplicate")) {
				nonMatchingValue = false;
			}

			if (nonMatchingValue === false) {
				filteredValues.push(row);
			}
		});
		this.setState({
			previousFilterOptions: JSON.parse(JSON.stringify(this.state.filterOptions))
		});
		console.log({ filteredValues, filterOptions: this.state.filterOptions });
		this.props.handleFilter(filteredValues, true, this.state.filterOptions);
	};

	checkApplyFilterDisabled = () => {
		const noneSelected = !this.state.filterOptions.some((option) => {
			return option.dataValue !== null;
		});
		const dataKeySelectedButNotDataValue = this.state.filterOptions.some((option) => {
			return option.dataKey !== null && option.dataValue === null;
		});
		const nothingChanged = _.isEqual(this.state.filterOptions, this.state.previousFilterOptions);
		return dataKeySelectedButNotDataValue || noneSelected || nothingChanged;
	};

	render() {
		const footerActionsElement = document.getElementById(`${this.props.hierarchyLevel}_footerActions`);

		return (
			<div className="workbookFilterV2">
				{this.renderFilterOptions()}

				{footerActionsElement &&
					createPortal(
						<>
							<Button onClick={this.clearFilters} display={BUTTON_DISPLAY.TEXT} data-tracking-id-alt="clear-filter-options">
								Reset
							</Button>
							<Button
								onClick={this.filterValues}
								display={BUTTON_DISPLAY.PRIMARY}
								disabled={this.checkApplyFilterDisabled()}
								data-tracking-id-alt="apply-filter-options"
							>
								Done
							</Button>
						</>,
						footerActionsElement
					)}
			</div>
		);
	}
}

export default Filter;
